import React from 'react';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    CircularProgress
} from '@mui/material';

const LezioniTable = ({ lezioni, loading }) => {
    if (!lezioni.length && !loading) {
        return (
            <Typography variant="body2" sx={{ color: 'text.secondary', p: 2 }}>
                Nessuna lezione trovata per questo corso
            </Typography>
        );
    }

    if (loading) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
                <CircularProgress size={24} sx={{ mr: 2 }} />
                <Typography>Caricamento lezioni...</Typography>
            </Box>
        );
    }

    return (
        <TableContainer component={Paper} sx={{ maxHeight: 400, overflow: 'auto' }}>
            <Table stickyHeader size="small">
                <TableHead>
                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell sx={{ fontWeight: 'bold' }}>Progressivo Lezione</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {lezioni.map((lezione, index) => (
                        <TableRow key={index} hover>
                            <TableCell>{lezione.progr_lezione}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default LezioniTable;
